import { create } from 'zustand';
import { toast } from '../../components/ui/toast';

/** §4.5: cart page/drawer edits share a guard because responses replace the cart snapshot. */
const useEditState = create<{ editing: boolean }>(() => ({ editing: false }));
async function edit(action: () => Promise<void>): Promise<void> {
  if (useEditState.getState().editing) return;
  useEditState.setState({ editing: true });
  try {
    await action();
  } catch {
    toast.error('Your cart could not update. Please try again.');
  } finally {
    useEditState.setState({ editing: false });
  }
}
export function useCartEditor() {
  return { editing: useEditState((s) => s.editing), edit };
}
